import script from "./PostComposer.vue?vue&type=script&setup=true&lang=js"
export * from "./PostComposer.vue?vue&type=script&setup=true&lang=js"

import "./PostComposer.vue?vue&type=style&index=0&id=2fbda535&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbda535"]])

export default __exports__